export default __webpack_public_path__ + "static/media/PRINT_LABEL.3046f660.svg";